// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"936":"01b1ef9b09957724","1221":"2f8daefc5b589185","3602":"3c9505981ebb6bc3","4937":"3e956fe39064f5da"}[chunkId] + ".css";
};